__turbopack_context__.v({
  "bodyLine": "styles-module__ykwcHW__bodyLine",
  "dmaxTitle": "styles-module__ykwcHW__dmaxTitle",
  "dmaxTitleLead": "styles-module__ykwcHW__dmaxTitleLead",
  "dmaxTitleStack": "styles-module__ykwcHW__dmaxTitleStack",
  "muxTitle": "styles-module__ykwcHW__muxTitle",
  "muxTitleLead": "styles-module__ykwcHW__muxTitleLead",
  "muxTitleStack": "styles-module__ykwcHW__muxTitleStack",
  "titleLead": "styles-module__ykwcHW__titleLead",
});
